import type { PermissionEnum } from '@Application/Security/Roles';
import type { PermissionGateMode } from '@UI/Providers/PermissionProvider/useHasPermission';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';
import type * as React from 'react';

type Props = {
	readonly permission: PermissionEnum | readonly PermissionEnum[];
	readonly mode?: PermissionGateMode;
	readonly fallback?: React.ReactNode;
	readonly children: React.ReactNode;
};

const WithPermission: React.FC<Props> = ({ permission, mode = 'all', fallback = null, children }) => {
	const granted = useHasPermission(permission, mode);

	return granted ? children : fallback;
};

export default WithPermission;
